/**
 * Mode d'affichage de la collection.
 *
 * Conservé dans localStorage : le choix survit ainsi à la navigation entre la
 * collection complète et le filtre par catégorie, qui démonte la page. C'est
 * une préférence propre au navigateur, jamais lue ailleurs.
 */
export const VIEW_MODES = {
    mosaic: 'mosaic',
    list: 'list',
};

const CLE_STOCKAGE = 'collectionViewMode';

export function readViewMode() {
    try {
        const stocke = localStorage.getItem(CLE_STOCKAGE);

        return stocke === VIEW_MODES.list ? VIEW_MODES.list : VIEW_MODES.mosaic;
    } catch (error) {
        // Navigation privée ou stockage refusé : on retombe sur la mosaïque.
        return VIEW_MODES.mosaic;
    }
}

export function writeViewMode(mode) {
    try {
        localStorage.setItem(CLE_STOCKAGE, mode);
    } catch (error) {
        // Sans persistance, le mode reste valable pour la session en cours.
    }
}
